import { Component, inject } from '@angular/core';
import {
	InstantSearchBoxComponent,
	DatePickerDropdownComponent,
	DateRangeView,
	MultiSelectDropdownComponent,
	SingleSelectDropdownComponent,
} from '@cumlaude/shared-components-inputs';
import { Option } from '@cumlaude/shared-utils';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { SENTIMENT_ICON } from './sentiment-icon';
import { AIChatConversatieStatus, getAIChatConversatieStatusName, RAIChatConversatie } from '@cumlaude/service-contract';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { CompactNumberPipe } from '@cumlaude/shared-pipes';
import { AIChatsZoekService, ShowOption } from './ai-chats-zoek.service';

@Component({
	selector: 'app-ai-chats-page',
	templateUrl: './ai-chats-page.component.html',
	styleUrls: ['./ai-chats-page.component.scss'],
	imports: [
		InstantSearchBoxComponent,
		AsyncPipe,
		CompactNumberPipe,
		DatePipe,
		DatePickerDropdownComponent,
		SingleSelectDropdownComponent,
		MultiSelectDropdownComponent,
		IconComponent,
		NgClass,
	],
})
export class AIChatsPageComponent {
	protected readonly SENTIMENT_ICON = SENTIMENT_ICON;
	private readonly router = inject(Router);

	protected readonly zoek = inject(AIChatsZoekService);

	showOptions = Object.values(ShowOption).map((value) => ({ text: value, value }));

	statusOptions = Object.values(AIChatConversatieStatus).map((status) => new Option(status, getAIChatConversatieStatusName(status)));

	aiChats$ = this.zoek.aiChats$;

	getSelectedShowOption() {
		return this.showOptions.find((option) => option.value === this.zoek.showOption$.value);
	}

	getGebruiker(chat: RAIChatConversatie): string {
		if (chat.impersonator) {
			return chat.impersonator.replace(/^[AD]\//, '');
		}
		return chat.account.naam;
	}

	gotoChat(chat: RAIChatConversatie) {
		this.router.navigate(['ai-chat', chat.id]);
	}

	DateRangeView = DateRangeView;

	getAIChatConversatieStatusName = getAIChatConversatieStatusName;
}
